import $ from 'jquery';
(<any>window).$ = $;
(<any>window).jQuery = $;

import { Peeky, RootUrlParam } from '@front/peeky/peeky';
import { PeekyState } from '@front/peeky/peeky.state';
let pk = new Peeky();
(<any>window).pk = pk;
(<any>window).Peeky = Peeky;

import { Editor, updatePerfectScroll } from '@front/editor/editor';
import { sleep } from '@shared/sleep';
import entityEncode from '@shared/entityEncode';
import { PeekyElement } from '@front/peeky/peeky.element';
import { scrollTo, transitionend } from '@front/dom';
import { requestAnimationFramePromise } from '@shared/requestanimationframepromise';
import { PeekyImage } from '@front/peeky/peeky.image';
import { PeekyVideo } from '@front/peeky/peeky.video';
import pkalert from 'editor/pkalert';
import { FocusObserver } from '@front/dom/FocusObserver';

let pkeditor: Editor;

//
//
// Initiate sites
// Initiate all "link" elements
pk.on('loadedState', function (param, state: PeekyState) {
  if (state.element.key === 'main') {
    var $peekySites;
    state.one('postAttached', async function () {
      $peekySites = state.$find('.peekySite');
      for (let i=0; i<$peekySites.length; i++) {
        let $this = $($peekySites[i]);
        let editorData = (<any>window)._editorData;
        let editor = new Editor(pk, editorData, $this);

        $this.data('editor', editor);
        pkeditor = editor;
        let preGoTo = function(param) {
          if (param && param.options && param.options._editorTriggered) return;
          var location = pk.location(param.location);
          if (location.pathname === window.location.pathname) return;
          editor.goToUrl(location.url, false, param);
        };
        pk.on('preGoTo', preGoTo);
        state.one('detached', function () {
          pk.off('preGoTo', preGoTo);
        });
      }
    });
  }
});


//
// Load site in preview-iframe
pk.on('loadedElement', function (param, element: PeekyElement) {
  if (element.key === 'bdyw') {
    let getPreviewSiteKeyFromParam = (param: RootUrlParam) => {
      if (!param) {
        param = pk.param();
      }
      if (param._kk._arg[0] === 'admin') {
        return param._kk._arg[1] || '';
      }
      return undefined;
    }
    const $previewWrap: JQuery<HTMLDivElement> = element.$find('.previewWrap');
    const previewWrap = $previewWrap[0];
    const $iframe: JQuery<HTMLIFrameElement> = $previewWrap.find('iframe');
    const iframe = $iframe[0];
    let currentPreviewSiteKey: string;
    element.on('prepareSwitchSearch', async function (param) {
      let newPreviewSite = getPreviewSiteKeyFromParam(param.location.param);
      // Switch site
      if (newPreviewSite && newPreviewSite !== currentPreviewSiteKey) {
        currentPreviewSiteKey = newPreviewSite;
        $iframe.attr('src', param.location.pathname.replace(/^\/admin/, '/preview'));
        $previewWrap.addClass('loading');
        $previewWrap.addClass('active');
      }
      // Switch to no site (back to dashboard)
      else if (!newPreviewSite && currentPreviewSiteKey) {
        currentPreviewSiteKey = newPreviewSite;
        $previewWrap.removeClass('active');
        await requestAnimationFramePromise(2);
        await Promise.all([
          transitionend(iframe),
          transitionend(previewWrap)
        ]);
        if (currentPreviewSiteKey === newPreviewSite) { // Make sure nothing changed during transition
          $iframe.attr('src', 'about:blank');
        }
      }
    });
    $iframe.on('load', function () {
      $previewWrap.removeClass('loading');
    })
  }
});



// Tie iframe pk with pk
pk.on('registerIframe', function (param, s) {
  var ipk: Peeky = param.window.pk;
  if (!ipk) return;

  function preGoTo(param) {
    let url: string;
    let location = param.location;
    if (!location || param.pkRecurse || pkeditor.unlinkedPreview) {
      return;
    }
    if (!param.options) param.options = {};
    location = this.location(location);
    if (location.pathname.indexOf('/admin') === 0) {
      url = location.pathname.replace(/^\/admin/, '/preview');
      if (ipk.underRoot(url)) {
        ipk.triggerAction('goTo', { location: url, pkRecurse: true, options: { reload: param.options.ipkReload } });
      }
    }
  };
  pk.on('preGoTo', preGoTo);

  function iframePreGoTo(this: Peeky, param) {
    let url: string;
    let location = param.location;
    if (!location || param.pkRecurse || pkeditor.unlinkedPreview) return;
    location = this.location(location);
    if (location.url.indexOf('/preview') === 0) {
      url = location.url.replace(/^\/preview/, '/admin');
      pk.triggerAction('goTo', { location: url, pkRecurse: true, ipkRecurse: true });
    }
  };
  ipk.on('preGoTo', iframePreGoTo);

  function iframePostLoadedState(param, state) {
    let $bindings = state.$find('[data-bind]');
    state.one('postAttached', function () {
      $bindings.each(function () {
        let $this = $(this);
        let fullkey = $this.data('bind');
        if (pkeditor) pkeditor.root.bind(fullkey, $this);
      });
    });
    if (pkeditor) {
      pkeditor.triggerAction('renderedPreviewFragment', state.$dom)
    }
  };
  ipk.on('postLoadedState', iframePostLoadedState);

  let pathArray = param.window.location.pathname.split('/');
  ipk.property('rootPath', '/' + pathArray[1] + '/' + pathArray[2] + '/');

  pk.on('reloadPreview', function () {
    ipk.triggerAction('goTo', { location: '', options: { reload: 'all' } });
  });


  // Tear down 
  $(param.window).on('unload', function () {
    pk.off('preGoTo', preGoTo);
    ipk.off('preGoTo', iframePreGoTo);
    ipk.off('postLoadedState', iframePostLoadedState);
  });

});



// Append /admin/..sitekey../ to relative urls (not on the root dash-board)
pk.on('loadedElement', function (param, e: PeekyElement) {
  if (e.key === 'bdy') {
    e.on('loadedState', function (param, target: PeekyState) {
      if (target.element.key === 'bdy' && !target.serialize()) {
        return; // Don't change root
      }
      target = target || this.state();

      let parentState = target;
      let bdyState: PeekyState;
      while (parentState) {
        if (parentState.element.key === 'bdy' && (bdyState = parentState)) break;
        parentState = parentState.element.parentState;
      }
      if (!bdyState) return;

      let arg = bdyState.param('_arg');
      if (!arg || !arg[0]) return;
      target.$find('a').each(function () {
        let $this: JQuery = $(this);
        let href = $this.attr('href').toString();
        let prefix = '/admin/' + arg[0];
        if ((/(^https?:\/\/|^\?)/).test(href)) return;
        $this.attr('href', prefix + href);
      });
    });
  };
});



// Wrap 
// Wrap antiscroll around body and form
pk.on('loadedState', function (param, target: PeekyState) {
  target.$find('.body').add(target.$find('#panes')).each(function () {
    var $this: JQuery = $(this);
    target.one('postAttached', async function attached(param, target: PeekyState) {
      if (target) return;
      $this.wrap('<div style="height: 100%; position: relative;"></div>');
      var $ps = $this.parent();
      let { updatePerfectScroll: updatePerfectScroll } = await import(/* webpackChunkName: "peekyeditor" */'@front/editor/editor');
      updatePerfectScroll($ps);
      // "Stupid" way to check for scrollbar updates
      $(document).on('keypress click', async function () {
        await sleep(500);
        updatePerfectScroll($ps);
      });
    });
  });
});



// Disable control+s
$(window).on('keypress', function (e) {
  if ((e.which === 115 && e.ctrlKey) || e.which === 19) return false;
  return true;
});



// Import sites
$('body').on('submit', '.clonesite', function (e) {
  var sitekey = $('.sitekey').val();
  var sourceHost = $('.sourceHost').val().toString();
  e.stopPropagation();
  e.preventDefault();
  if (!sitekey) {
    return;
  }
  pkeditor.cloneSite(sitekey, sourceHost);
});
$('body').on('submit', '.importSite', function (e) {
  e.stopPropagation();
  e.preventDefault();

  let $form = $(this);
  let $fileElement = <JQuery<HTMLInputElement>>$form.find('.file');
  let fileElement = $fileElement[0];
  var file = fileElement.files[0];
  var reader = new FileReader();
  reader.addEventListener('load', function (e) {
    var text = e.target.result.toString();
    var elements = JSON.parse(text);
    pkeditor.addSite('import', elements);
  });
  if (file) {
    reader.readAsText(file);
  }
});


$('body').on('click', '.dynlink', function () {
  var $href = $(this).find('.href');
  var href = $href.text();
  if (href) {
    window.open(href);
  }
});


let login = async function(options, $dom?: JQuery) {
  options = options || {};
  let username = options.username;
  let password = options.password;
  let remember = options.remember;
  let base = window.location.protocol + "//" + window.location.host + "/";
  let url = new URL(options.url || window.location.href, base);
  if (url.pathname.indexOf('/admin') !== 0) {
    url = new URL('/admin/', base);
  }

  let result = await pk.triggerAction('goTo', {
    location: url.toString(),
    $dom: $dom,
    options: {
      reload: 'all',
      ajax: {
        method: 'POST',
        data: {
          '_kk.login.email': username,
          '_kk.login.password': password,
          '_kk.sessionTimeout': !!remember ? -1 : undefined
        }
      }
    },
    actions: {
      preCreateStates: async function(param) {
        if (!param.metadata.status.OK_AUTH_LOGIN) {
          this.triggerAction('cancel');
          throw undefined;
        }
      }
    }
  });

  if (!result || !result.metadata || !result.metadata.status) {
    pkalert('An unknown error occurred, please try again later.');
    return false;
  } else if (result.metadata.status.OK_AUTH_LOGIN) {
    return true;
  } else {
    pkalert('Incorrect username and/or password');
    return false;
  }
}


let logout = async function () {
  await pk.goTo('/', {
    reload: 'all',
    ajax: {
      method: 'POST',
      data: {
        '_kk.logout': true
      }
    }
  });
  if (pkeditor) {
    pkeditor = undefined;
  }
};


let requestPasswordReset = async function(options: { username?: string, url?: string } = {}, $dom?) {
  let username = options.username;
  let base = window.location.protocol + "//" + window.location.host + "/";
  let url = new URL(options.url || window.location.href, base);

  let result;
  try {
    result = await pk.triggerAction('goTo', {
      location: url.toString(),
      $dom: $dom,
      noScroll: true,
      options: {
        reload: 'all',
        ajax: {
          method: 'POST',
          data: {
            'user.id': username,
            'user.entity': 'user',
            'user.resetPassword': true
          }
        }
      },
      actions: {
        preCreateStates: async function (param) {
          // Don't switch state on a password reset
          this.triggerAction('cancel');
          throw undefined;
        }
      }
    });
  } catch (e) {
  }

  if (result.metadata.status.ER_USER_NOTFOUND) {
    pkalert('User <strong>' + entityEncode(username) + '</strong> was not found')
  }
  else if (result.metadata.status.OK_USER_RESETREQUESTED) {
    pkalert('Password reset requested for <strong>' + entityEncode(username) + '</strong>');
  }
};

let register = async function(options, $dom?, callback?) {
  options = options || {};
  callback = callback || function () { };
  const username = options.username;
  const base = window.location.protocol + "//" + window.location.host + "/";
  let url = new URL(options.url || window.location.href, base);
  if (url.pathname.indexOf('/admin') !== 0) {
    url = new URL('/admin/', base);
  }


  let result = await pk.triggerAction('goTo', {
    location: url.toString(),
    $dom: $dom,
    options: {
      reload: 'all',
      ajax: {
        method: 'POST',
        data: {
          'user.insert.email': username,
          'user.entity': 'user',
          'user.postlogin': true
        }
      }
    },
    actions: {
      preCreateState: async function (param) {
        if (param.metadata.status.ER) {
          this.triggerAction('cancel');
          throw undefined;
        }
      }
    }
  });

  if (!result.metadata) {
    pkalert('An unknown error occurred, please try again later.');
  } else if (result.metadata?.status?.ER_DB_DUPLICATE) {
    pkalert('The e-mail address you entered is already registered.');
  } else if (result.metadata?.status?.ER) {
    pkalert('An unknown error occurred, please try again later.');
  }
};


let resetPassword = async function (options: { resetid: string, password: string, url?: string }, $dom?, callback?) {
  const resetid = options.resetid;
  const password = options.password;
  const url = '/';

  let result = await pk.triggerAction('goTo', {
    location: url,
    $dom: $dom,
    options: {
      reload: 'all',
      ajax: {
        method: 'POST',
        data: {
          'user.entity': 'user',
          'user.resetid': resetid,
          'user.setPassword': password
        }
      }
    },
    actions: {
      preCreateState: async function (param) {
/*
        if (!param.metadata.status.OK_USER_SETPASSWORD) {
          let currentState = param.stateInfo.element.currentState;
          currentState.triggerAction('cancelLoadState');
          param._cancel = true;
          throw undefined;
        }
*/
      }
    }
  });

  if (result.metadata.status.ER_USER_INVALID_RESETID) {
    pkalert('The reset token you submitted has expired, or is invalid. Please request a new password reset.');
    return false;
  }
  if (result.metadata.status.OK_USER_SETPASSWORD) {
    pkalert('Your password was set.');
  }
};


// Find register/login form and toggles
pk.on('loadedState', function (param, state) {
  state.$find('.register').each(function () {
    var $this = $(this)
      , $loginVisible = $this.find('.loginVisible:not(.slide)')
      , $loginVisibleSlide = $this.find('.loginVisible.slide')
      , $registerVisible = $this.find('.registerVisible')
      , $cancelVisible = $this.find('.cancelVisible')
      , $requestVisible = $this.find('.requestVisible')
      , $form = $this.find('form')
      , $emailBox = $this.find('.emailBox')
      , $email = $emailBox.find('input')
      , $passwordBox = $this.find('.passwordBox')
      , $password = $passwordBox.find('input')
      , $button = $this.find('.button')
      , $submit = $this.find('input.submit')
      , $logout = $this.find('.logoutlink')
      , $remember = $this.find('.remember')
      , $sessionTimeout = $('<input type="hidden">')
      , $meta
      , activated = $this.data('activated') ? true : false;

    function showRegister(nofocus?) {
      $emailBox.filter(':hidden').slideDown(250);
      $passwordBox.filter(':visible').slideUp(250);
      $loginVisibleSlide.filter(':visible').stop().slideUp(250);
      $loginVisible.hide();
      $cancelVisible.hide();
      $requestVisible.not('.slide').hide();
      $requestVisible.filter('.slide').slideUp(250);
      $registerVisible.show();
      activated = true;
      $email.focus();
      $form.data('at', 'register');
    };

    function showLogin(nofocus?) {
      $emailBox.filter(':hidden').slideDown(250);
      $passwordBox.filter(':hidden').slideDown(250);
      $loginVisibleSlide.filter(':hidden').stop().slideDown(250);
      $registerVisible.hide();
      $cancelVisible.hide();
      $requestVisible.not('.slide').hide();
      $requestVisible.filter('.slide').slideUp(250);
      $loginVisible.show();
      activated = true;
      $email.focus();
      $form.data('at', 'login');
    };

    function showPasswordrequest(nofocus?) {
      $emailBox.filter(':hidden').slideDown(250);
      $passwordBox.filter(':visible').slideUp(250);
      $registerVisible.hide();
      $cancelVisible.hide();
      $loginVisible.hide();
      $requestVisible.not('.slide').show();
      $requestVisible.filter('.slide').slideDown(250);
      $loginVisibleSlide.filter(':visible').slideUp(250);
      activated = true;
      $email.focus();
      $form.data('at', 'requestPasswordreset');
    };

    function hideAll() {
      if ($emailBox.is(':visible')) $emailBox.slideUp(250);
      if ($passwordBox.is(':visible')) $passwordBox.slideUp(250);
      if ($meta) $meta.remove();
      $sessionTimeout.removeAttr('name');
      $sessionTimeout.detach();
      $loginVisibleSlide.filter(':visible').stop().slideUp(250);
      $loginVisible.hide();
      $cancelVisible.hide();
      $requestVisible.not('.slide').hide();
      $requestVisible.filter('.slide').slideUp(250);
      $registerVisible.show();
      activated = false;
      $form.data('at', '');
    };


    async function closeClick(e) {
      await sleep(20); // Give password managers some time
      if ($(e.target).parents().add(e.target).filter($this).length > 0 || $email.val() || $password.val()) {
        setTimeout(function () {
          $(document).one('click', closeClick);
        }, 0);
        return;
      }
      hideAll();
    };

    $button.on('click', function () {
      if (!activated) {
        $(document).one('click', closeClick);
        showRegister();
      } else {
        $form.submit();
      }
    });

    $submit.on('focus', function () {
      $button.addClass('focus');
    });
    $submit.on('blur', function () {
      $button.removeClass('focus');
    });
    $form.on('submit', function (e) {
      e.preventDefault();
      e.stopPropagation();
      let $form = $(this);
      let username = $form.find('input.email').val() || '';
      let password = $form.find('input.password').val() || '';
      let remember = $form.find('input.remember').is(':checked');
      if ($email.length > 0 && ($email.val().toString() || '').indexOf('@') <= 0) {
        pkalert('Invalid e-mail address'); //, $email);
        return;
      }
      if ($form.data('at') === 'register') {
        register({ username: username });
      }
      else if ($form.data('at') === 'requestPasswordreset' || $form.is('.requestPasswordreset')) {
        requestPasswordReset({ username: username.toString() });
      }
      else if ($form.is('.passwordreset')) {
        let resetid = $form.find('.resetid').val();
        let password = $form.find('.password').val();
        resetPassword({ resetid: resetid.toString(), password: password.toString() });
      }
      else {
        let result = login({
          username: username,
          password: password,
          remember: remember
        });
      }
    });



    $this.on('click', '.loginlink', async function () {
      if (!activated) {
        await sleep(0);
        $(document).one('click', closeClick);
      }
      showLogin();
    });
    $this.on('click', '.registerlink', async function () {
      if (!activated) {
        await sleep(0);
        $(document).one('click', closeClick);
      }
      showRegister();
    });
    $this.on('click', '.requestlink', function () {
      showPasswordrequest();
    });
    $this.on('selectstart', '.loginlink,.registerlink,.requestlink', false);

    $logout.on('click', logout);

    $remember.on('change', function () {
      if ($(this).val()) $sessionTimeout.val('-1');
      else $sessionTimeout.val('');
    });

    if ($this.data('showlogin')) {
      showLogin();
    }
  });
});

//
pk.on('loadedState', function (param, state) {
  // Find input-text overlays
  state.$find('label.overlay').each(function () {
    var $label = $(this)
      , $input = $label.next('input')
      , $parent = $label.parent()
      , hidden = false;
    $label.css({
      position: 'absolute',
      color: 'black'
    });

    // Check for auto-fill after any document key press
    function checkAuto(e) {
      setTimeout(function () {
        if (e && e.target === $input[0]) return;
        if ($input.val() === '') return;
        setTimeout(function () {
          $input.trigger('autofill');
        });
      });
    };

    $input.on('keydown change autofill', function () {
      setTimeout(function () {
        if ($input.val() === '') {
          if (hidden) {
            $label.show();
            hidden = false;
            $(document).on('keyup', checkAuto);
          }
        } else if (!hidden) {
          $label.hide();
          hidden = true;
          $(document).off('keyup', checkAuto);
        }
      }, 0);
    });
    $input.on('blur', function () {
      $label.add($parent).removeClass('focus');
    });
    $input.on('focus', function () {
      $label.add($parent).addClass('focus');
    });

    setTimeout(checkAuto, 100);
  });
});


// Listen to scroll event when on front page
pk.on('loadedState', function (param, state) {
  if (!state || state.element.key !== 'main') return;
  if (!state.equals('')) return;

  var $more = state.$dom.find('#more')
    , height
    , fixed = false;

  function listenScroll() {
    if ($(window).scrollTop() >= height) {
      if (!fixed) {
        $more.addClass('fixed');
        fixed = true;
      }
    } else {
      if (fixed) {
        $more.removeClass('fixed');
        fixed = false;
      }
    }
  };
  function listenResize() {
    height = $(window).height();
  };

  state.on('attached', function () {
    $(window).on('scroll touchmove focus', listenScroll);
    $(window).on('resize', listenResize);
    listenResize();
    listenScroll();
  });
  state.on('detached', function () {
    $(window).off('scroll touchmove focus', listenScroll);
    $(window).off('resize', listenResize);
  });

});


// Transitions
pk.on('loadedElement', function (param, element) {
  if (element.key === '_kk' || element.key === '_pre') {
    return;
  }

  async function preSwitchState(param) {
    let $attach = param.$attach;
    $attach.addClass('pk-switchIn');
    $attach.addClass('pk-switchInInit');

    if (param.$detach) {
      await requestAnimationFramePromise(2);
      await transitionend(param.$detach[0]);
    }
  }

  async function postSwitchState(param) {
    let $attach = param.$attach;
    // Wait for switchIn animation to end
    await requestAnimationFramePromise(2);
    if (param.$detach) {
      param.$detach.removeClass('pk-switchOut'); // param.$detach should be hidden at this point
    }

    await requestAnimationFramePromise(2);
    $attach.removeClass('pk-switchInInit');

    await transitionend($attach[0]);
    element.$dom.removeClass('pk-loading');
    $attach.removeClass('pk-switchIn');
  };

  // Mark current states as switching out
  element.bindAction('prepareSwitchState', async function (param) {
    if (param.child) {
      return;
    }
    let state = element.state();
    element.$dom.addClass('pk-loading');
    state.$dom.addClass('pk-switchOut');
    state.$dom.addClass('pk-switchOutInit');

    // Avoid double binding
    element.unbindAction('preSwitchState', preSwitchState);
    element.unbindAction('postSwitchState', postSwitchState);
    element.oneAction('preSwitchState', preSwitchState);
    element.oneAction('postSwitchState', postSwitchState);

    await requestAnimationFramePromise(2);
    state.$dom.removeClass('pk-switchOutInit');
  });

  element.bindAction('cancelSwitchState', async function(param) {
    if (param.child) {
      return;
    }
    let state = element.state();
    element.$dom.removeClass('pk-loading');
    state.$dom.removeClass('pk-switchOut');
    state.$dom.removeClass('pk-switchOutInit');
  });
});

pk.on('loadedState', (param, state) => {
  if (state.element.key === 'main') {
    state.bindAction('attached', async (param) => {
      let $detach: JQuery = param.$detach;
      if ($detach) {
        let $box = $detach.find('.frontBox');
        await transitionend($box[0]);
      }
    });
  }
});


// Loading class
pk.on('prepareSwitch', function (param) {
  if (param.initial !== true) {
    pk.triggerAction('pk-loading');
    pk.one('switched', function () {
      pk.triggerAction('pk-loaded', 'loading');
    });
  }
});


/*
 * Navigation animations for front page
 */
pk.on('prepareSwitchState', async function (param) {
  let switchElement: PeekyElement = param.switchElement;
  if (switchElement.key !== 'fp') {
    return;
  }

  let switchOutDOM = switchElement.state().DOM;
  switchOutDOM.style.opacity = '0';
  switchOutDOM.style.transform = 'translateX(-2%) translateZ(0)';
  switchOutDOM.style.transition = 'all .3s cubic-bezier(0.25, 1, 0.5, 1)';

  let switchOutPromise = transitionend(switchOutDOM);

  switchElement.oneAction('preSwitchState', async function (param) {
    let detachDOM = param.detach.DOM;
    let attachDOM = param.attach.DOM;

    await switchOutPromise;

    detachDOM.style.display = 'none';
    detachDOM.style.opacity = '';
    detachDOM.style.transform = '';
    detachDOM.style.transition = '';

    attachDOM.style.opacity = '0';
    attachDOM.style.display = '';
    attachDOM.style.transform = 'translateX(2%) translateZ(0)';
    attachDOM.style.transition = 'all 0s';
    await requestAnimationFramePromise(2);
    attachDOM.style.opacity = '1';
    attachDOM.style.transform = 'translateX(0) translateZ(0)';
    attachDOM.style.transition = 'all .3s cubic-bezier(0.25, 1, 0.5, 1)';
    await transitionend(attachDOM);
  });
});


// Check if we should scroll up/down on navigation
pk.on('preGoTo', function (this: Peeky, param) {
  let location = this.location(param.location);
  let arg0 = location.param._kk._arg[0];

  if (param.noScroll) {
    return;
  }
  else if (arg0 === 'about') {
    scrollTo(document.getElementById('more'), 300);
  } else if (!arg0) {
    scrollTo(0, 300);
  }
});


// Initialize images
pk.on('loadedState', function (param, state) {
  state.$find('[data-image]').each(function () {
    let image = <HTMLImageElement>this;
    let peekyImage = new PeekyImage(image, pk);
		let focusObserver = new FocusObserver(image, { margin: 400 });
		focusObserver.onFocus(() => {
			peekyImage.focusIn();
		});
		focusObserver.onFocusOut(() => {
			peekyImage.focusOut();
		});

		state.on('attached', function() {
			focusObserver.activate();
		});
		state.on('detached', function() {
			focusObserver.deactivate();
		});
  });
});

// Initialize videos
pk.on('loadedState', function(param, state) {
	state.$find('[data-video]').each(function() {
		let video = <HTMLVideoElement>this;
		var peekyVideo = new PeekyVideo(video, pk);
		let focusObserver = new FocusObserver(video, { margin: 400 });
		focusObserver.onFocus(() => {
			peekyVideo.focusIn();
		});
		focusObserver.onFocusOut(() => {
			peekyVideo.focusOut();
		});

		state.on('attached', function() {
			focusObserver.activate();
		});
		state.on('detached', function() {
			focusObserver.deactivate();
		});
	});
});


$('body').on('click', '.logout.clickable', function () {
  logout();
});


pk.interactor('a:not(.custom)');
pk.interactor('form:not(.custom)');